@if (!isMaintenanceMode) {
  <div>
    <router-outlet></router-outlet>
  </div>
}
@if (isMaintenanceMode) {
  <app-maintenance></app-maintenance>
}
